import React from 'react';

import { BecomeAClientBackground, BecomeAClientHeaderSpan, BecomeAClientImageContainer, BecomeAClientImage } from './BecomeAClient.styled';

import { BecomeAClientWrapperMobile, BecomeAClientButtonMobile, BecomeAClientHeaderMobile, BecomeAClientSubmitMobile } from './BecomeAClientMobile.styled';

import config from './../../config';

export default class BecomeAClientMobile extends React.Component {
   public render() {
      return (
         <BecomeAClientWrapperMobile>
            <BecomeAClientBackground />
            <BecomeAClientImageContainer>
               <BecomeAClientImage width={300} height={250} src={`${config.baseName}/images/become-a-client-cta-min.png`} alt='Become a Client' />
            </BecomeAClientImageContainer>
            <BecomeAClientHeaderMobile>
               <BecomeAClientHeaderSpan>Powerful data and analysis</BecomeAClientHeaderSpan> on nearly every digital topic.
            </BecomeAClientHeaderMobile>
            <BecomeAClientSubmitMobile>
               <BecomeAClientButtonMobile
                  href={`${config.iiHomeUrl}/become-a-client/`}
                  rel='noreferrer'
                  data-analytics='Forecast-CTA-BecomeAClient-Mobile'
                  id='Forecast-CTA-BecomeAClient-Mobile'
               >
                  Become a Client
               </BecomeAClientButtonMobile>
            </BecomeAClientSubmitMobile>
         </BecomeAClientWrapperMobile>
      );
   }
}
